/**
 * React Query hook returning the stored prop labels for a component.
 *
 * Powers the prop pills section of the config page. Consumers merge the
 * returned rows with the component's `defaultPropLabels` from the
 * registry to produce the final label displayed to the admin.
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import {
  componentRulesService,
  type ComponentPropLabelDTO,
} from '../../api/componentRulesService';
import { componentPropLabelsKeys } from './queryKeys';

/** Fetch every prop label currently stored for a component id. */
export function useComponentPropLabels(
  componentId: string,
): UseQueryResult<ComponentPropLabelDTO[]> {
  return useQuery<ComponentPropLabelDTO[]>({
    queryKey: componentPropLabelsKeys.list(componentId),
    queryFn: () => componentRulesService.listPropLabels(componentId),
    enabled: componentId !== '',
  });
}
